import Vue from 'vue'
import ElementUI from 'element-ui'
// import '../element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)
